
import React from "react";
import SectionTitle from "@others/title-section.layout";
import {Box, Chip, Container, Divider, Grid, Paper, Stack, Typography} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLeaf,
    faVoteYea,
    faUserCheck,
    faHandshake,
    faEuroSign,
    faTree,
    faUsers,
    faComments,
    faEnvelope,
    faFilePdf,
    faDownload,
    faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import candidatePhoto from "../../assets/images/others/jpg-2.png";
// @ts-ignore
import teamPhoto from "../../assets/images/others/list-people.png";

const POST20251009: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mb: 6 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />

            <Box mt={3} mb={3}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    <FontAwesomeIcon icon={faLeaf} style={{ marginRight: 8 }} />
                    VLD2026 - Tract 2 du 9&nbsp;octobre&nbsp;2025
                </Typography>
                <Divider sx={{ mt: 1, mb: 3 }} />
            </Box>

            <Stack spacing={4}>
                {/* Section 1: Présentation du candidat */}
                <Paper elevation={3} sx={{ p: 4, background: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)" }}>
                    <Grid container spacing={4} alignItems="center">
                        <Grid size={{ xs:12, md: 4}}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <img
                                    src={candidatePhoto}
                                    alt="Jean-Philippe GUIBERT"
                                    style={{
                                        width: "100%",
                                        maxWidth: 300,
                                        borderRadius: 12,
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs:12, md: 8}}>
                            <Typography variant="h4" fontWeight={700} color="primary" gutterBottom>
                                Jean-Philippe GUIBERT
                            </Typography>

                            <Stack spacing={1.5} sx={{ mb: 3 }}>
                                <Typography variant="body1">
                                    <b>Marié, 3 enfants</b>
                                </Typography>
                                <Typography variant="body1">
                                    • Ingénieur commercial - Responsable Assurance qualité
                                </Typography>
                                <Typography variant="body1">
                                    • Secrétaire général de l'Institut Prospective et Sécurité de l'Europe
                                </Typography>
                                <Typography variant="body1">
                                    • Officier de Réserve
                                </Typography>
                                <Typography variant="body1">
                                    • Depuis 2001, photographe indépendant
                                </Typography>
                                <Typography variant="body1">
                                    • Maire adjoint en charge des affaires scolaires durant le Covid
                                </Typography>
                            </Stack>

                            <Paper
                                elevation={2}
                                sx={{
                                    p: 2.5,
                                    bgcolor: "white",
                                    borderLeft: "5px solid #43a047"
                                }}
                            >
                                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                    <Typography
                                        variant="body1"
                                        fontStyle="italic"
                                        fontWeight={600}
                                        color="text.primary"
                                    >
                                        « Préserver notre nature, respecter notre histoire, bâtir notre avenir.
                                        Faisons de Bois-le-Roi un lieu de confiance, de fierté et d'unité. »
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>

                {/* Section 2: Élections municipales */}
                <Paper elevation={3} sx={{ p: 4, bgcolor: "#e3f2fd" }}>
                    <Stack spacing={3}>
                        <Box textAlign="center">
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" mb={2}>
                                <FontAwesomeIcon icon={faVoteYea} color="#1976d2" size="2x" />
                                <Typography variant="h5" fontWeight={700} color="primary">
                                    Élections municipales - Bois-le-Roi
                                </Typography>
                            </Stack>
                            <Typography variant="h6" fontWeight={600} color="#d32f2f">
                                Votez les 15 et 22 mars 2026
                            </Typography>
                        </Box>

                        <Divider />

                        <Box>
                            <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                                <FontAwesomeIcon icon={faUserCheck} color="#43a047" size="lg" />
                                <Typography variant="h6" fontWeight={600} color="primary">
                                    Pensez à vérifier votre inscription !
                                </Typography>
                            </Stack>

                            <Typography paragraph color="text.secondary">
                                Pour pouvoir voter aux élections municipales de mars 2026, vous devez être inscrit(e)
                                sur les listes électorales de Bois-le-Roi.
                            </Typography>

                            <Paper elevation={1} sx={{ p: 2.5, bgcolor: "white", mb: 2 }}>
                                <Typography variant="subtitle1" fontWeight={700} gutterBottom color="primary">
                                    <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: 8 }} />
                                    Vérifiez votre inscription en ligne
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={1}>
                                    Rendez-vous sur{" "}
                                    <a
                                        href="https://www.service-public.fr/particuliers/vosdroits/services-en-ligne-et-formulaires/ISE"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1976d2", fontWeight: 600 }}
                                    >
                                        service-public.fr
                                    </a>
                                    {" "}pour vérifier si vous êtes bien inscrit(e).
                                </Typography>
                            </Paper>

                            <Paper elevation={1} sx={{ p: 2.5, bgcolor: "white" }}>
                                <Typography variant="subtitle1" fontWeight={700} gutterBottom color="primary">
                                    <FontAwesomeIcon icon={faHandshake} style={{ marginRight: 8 }} />
                                    Vous n'êtes pas encore inscrit(e) ?
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={1}>
                                    Vous pouvez vous inscrire jusqu'au <b>6 février 2026</b> :
                                </Typography>
                                <Stack component="ul" spacing={0.5} sx={{ pl: 3 }}>
                                    <Typography component="li" variant="body2" color="text.secondary">
                                        En ligne sur service-public.fr
                                    </Typography>
                                    <Typography component="li" variant="body2" color="text.secondary">
                                        En mairie de Bois-le-Roi
                                    </Typography>
                                    <Typography component="li" variant="body2" color="text.secondary">
                                        Par courrier postal
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Box>

                        <Box
                            sx={{
                                bgcolor: "#fff3e0",
                                p: 2,
                                borderRadius: 2,
                                border: "2px solid #ffa000"
                            }}
                        >
                            <Typography variant="body2" fontWeight={600} color="#e65100" align="center">
                                ⚠️ N'attendez pas le dernier moment ! Vérifiez dès maintenant votre situation.
                            </Typography>
                        </Box>
                    </Stack>
                </Paper>

                {/* Section 3: Les 3 engagements */}
                <Paper elevation={3} sx={{ p: 4, background: "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)" }}>
                    <Stack spacing={3}>
                        <Typography variant="h5" fontWeight={700} color="primary" textAlign="center" mb={2}>
                            <FontAwesomeIcon icon={faHandshake} style={{ marginRight: 10 }} />
                            Mes 3 engagements prioritaires
                        </Typography>

                        <Stack spacing={2}>
                            <Paper elevation={2} sx={{ p: 3, bgcolor: "white", borderLeft: "5px solid #1976d2" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box
                                        sx={{
                                            bgcolor: "#e3f2fd",
                                            borderRadius: "50%",
                                            width: 50,
                                            height: 50,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={700} color="primary">1</Typography>
                                    </Box>
                                    <Box>
                                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                            <FontAwesomeIcon icon={faEuroSign} color="#1976d2" />
                                            <Typography variant="h6" fontWeight={700} color="primary">
                                                Retrouver des finances saines et transparentes
                                            </Typography>
                                        </Stack>
                                        <Typography variant="body2" color="text.secondary">
                                            Assurer une gestion rigoureuse et claire des deniers publics,
                                            avec des comptes accessibles à tous les citoyens.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>

                            <Paper elevation={2} sx={{ p: 3, bgcolor: "white", borderLeft: "5px solid #43a047" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box
                                        sx={{
                                            bgcolor: "#e8f5e9",
                                            borderRadius: "50%",
                                            width: 50,
                                            height: 50,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={700} color="#43a047">2</Typography>
                                    </Box>
                                    <Box>
                                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                            <FontAwesomeIcon icon={faTree} color="#43a047" />
                                            <Typography variant="h6" fontWeight={700} color="#2e7d32">
                                                Agir pour préserver notre qualité de vie
                                            </Typography>
                                        </Stack>
                                        <Typography variant="body2" color="text.secondary">
                                            En affirmant l'identité de Bois-le-Roi : protéger notre environnement,
                                            notre patrimoine et notre cadre de vie unique.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>

                            <Paper elevation={2} sx={{ p: 3, bgcolor: "white", borderLeft: "5px solid #f57c00" }}>
                                <Stack direction="row" alignItems="flex-start" spacing={2}>
                                    <Box
                                        sx={{
                                            bgcolor: "#fff3e0",
                                            borderRadius: "50%",
                                            width: 50,
                                            height: 50,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0
                                        }}
                                    >
                                        <Typography variant="h5" fontWeight={700} color="#f57c00">3</Typography>
                                    </Box>
                                    <Box>
                                        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                            <FontAwesomeIcon icon={faUsers} color="#f57c00" />
                                            <Typography variant="h6" fontWeight={700} color="#e65100">
                                                Retisser la confiance démocratique
                                            </Typography>
                                        </Stack>
                                        <Typography variant="body2" color="text.secondary">
                                            Grâce à des concertations régulières et sincères avec tous les habitants,
                                            pour une démocratie participative authentique.
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Paper>
                        </Stack>
                    </Stack>
                </Paper>

                {/* Section 4: Votre avis nous intéresse */}
                <Paper elevation={3} sx={{ p: 4, bgcolor: "#f3e5f5" }}>
                    <Stack spacing={3} alignItems="center">
                        <Stack direction="row" spacing={2} alignItems="center">
                            <FontAwesomeIcon icon={faComments} color="#7b1fa2" size="2x" />
                            <Typography variant="h5" fontWeight={700} color="#7b1fa2">
                                Votre avis nous intéresse !
                            </Typography>
                        </Stack>

                        <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth={600}>
                            Partagez vos idées, vos préoccupations et vos suggestions.
                            Ensemble, construisons le Bois-le-Roi de demain.
                        </Typography>

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ width: "100%" }} justifyContent="center">
                            <Paper
                                elevation={2}
                                sx={{
                                    p: 2.5,
                                    bgcolor: "white",
                                    flex: 1,
                                    maxWidth: 350,
                                    textAlign: "center"
                                }}
                            >
                                <FontAwesomeIcon icon={faComments} color="#7b1fa2" size="lg" />
                                <Typography variant="subtitle1" fontWeight={700} color="primary" mt={1} mb={1}>
                                    Participez aux enquêtes
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={2}>
                                    Donnez votre avis sur les sujets qui vous concernent
                                </Typography>
                                <a
                                    href="https://vld-boisleroi.fr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none" }}
                                >
                                    <Chip
                                        label='Rubrique "Enquêtes"'
                                        sx={{
                                            bgcolor: "#7b1fa2",
                                            color: "white",
                                            fontWeight: 600,
                                            "&:hover": {
                                                bgcolor: "#6a1b9a"
                                            }
                                        }}
                                        clickable
                                    />
                                </a>
                            </Paper>

                            <Paper
                                elevation={2}
                                sx={{
                                    p: 2.5,
                                    bgcolor: "white",
                                    flex: 1,
                                    maxWidth: 350,
                                    textAlign: "center"
                                }}
                            >
                                <FontAwesomeIcon icon={faEnvelope} color="#7b1fa2" size="lg" />
                                <Typography variant="subtitle1" fontWeight={700} color="primary" mt={1} mb={1}>
                                    Contactez-nous
                                </Typography>
                                <Typography variant="body2" color="text.secondary" mb={2}>
                                    Écrivez-nous directement par email
                                </Typography>
                                <a
                                    href="mailto:democratie.blr@gmail.com"
                                    style={{ textDecoration: "none" }}
                                >
                                    <Chip
                                        icon={<FontAwesomeIcon icon={faEnvelope} style={{ color: "white" }} />}
                                        label="democratie.blr@gmail.com"
                                        sx={{
                                            bgcolor: "#7b1fa2",
                                            color: "white",
                                            fontWeight: 600,
                                            "&:hover": {
                                                bgcolor: "#6a1b9a"
                                            }
                                        }}
                                        clickable
                                    />
                                </a>
                            </Paper>
                        </Stack>
                    </Stack>
                </Paper>

                {/* Section 5: Photo de l'équipe */}
                <Paper elevation={3} sx={{ p: 4, bgcolor: "#e8eaf6" }}>
                    <Typography variant="h5" fontWeight={700} color="primary" textAlign="center" mb={3}>
                        <FontAwesomeIcon icon={faUsers} style={{ marginRight: 10 }} />
                        Notre équipe VLD2026
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <img
                            src={teamPhoto}
                            alt="Équipe VLD2026"
                            style={{
                                width: "100%",
                                maxWidth: 900,
                                borderRadius: 12,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                            }}
                        />
                    </Box>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        textAlign="center"
                        mt={3}
                        fontStyle="italic"
                    >
                        Une équipe engagée, proche de vous, au service de Bois-le-Roi
                    </Typography>
                </Paper>

                {/* Section 6: Télécharger le PDF */}
                <Box
                    sx={{
                        mt: 5,
                        mb: 5,
                        bgcolor: "#f7f3ee",
                        borderRadius: 3,
                        p: 4,
                        boxShadow: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                        <FontAwesomeIcon icon={faFilePdf} size="2x" style={{ color: "#d32f2f" }} />
                        <Typography variant="h6" fontWeight={700} color="primary">
                            Télécharger le tract au format PDF
                        </Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary" mb={2} align="center">
                        Retrouvez toutes les informations sur la candidature de Jean-Philippe Guibert
                        sous forme de tract à imprimer ou partager !
                    </Typography>
                    <a
                        href="/files/TRACT-VLD2026-2-2025-10-09.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                        }}
                    >
                        <Chip
                            icon={<FontAwesomeIcon icon={faDownload} style={{ color: "#fff" }} />}
                            label="Télécharger le PDF"
                            sx={{
                                bgcolor: "#d32f2f",
                                color: "#fff",
                                px: 3,
                                py: 2,
                                fontWeight: 600,
                                fontSize: "1rem",
                                "&:hover": {
                                    bgcolor: "#b71c1c",
                                },
                            }}
                            clickable
                        />
                    </a>
                </Box>
            </Stack>
        </Container>
    );
};

export default POST20251009;